import 'mocks';
import 'nprogress/nprogress.css';

import App from 'App';
import { AuthProvider } from 'contexts/JWTAuthContext';
import { ShiftSessionProvider } from 'contexts/ShiftSessionContext';
import { SidebarProvider } from 'contexts/SidebarContext';
import ScrollTop from 'hooks/useScrollTop';
import { queryClient } from 'libs/query';
import { SnackbarProvider } from 'notistack';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorker from 'serviceWorker';
import store from 'store';

const persistor = persistStore(store);
const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SidebarProvider>
          <BrowserRouter>
            <ScrollTop />
            <AuthProvider>
              <ShiftSessionProvider>
                <QueryClientProvider client={queryClient}>
                  <SnackbarProvider
                    maxSnack={6}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                  >
                    <App />
                  </SnackbarProvider>
                </QueryClientProvider>
              </ShiftSessionProvider>
            </AuthProvider>
          </BrowserRouter>
        </SidebarProvider>
      </PersistGate>
    </Provider>
  </HelmetProvider>,
);

serviceWorker.unregister();
